import React from 'react';

import { useField } from 'formik';

import { Radio, RadioToggle } from '..';

import './index.scss';

const Switcher = ({ name, options }) => {
  const [field] = useField(name);

  return (
    <RadioToggle>
      {Array.isArray(options) &&
        options.map((option) => (
          <Radio
            {...field}
            key={option.value}
            value={option.value}
            checked={field.value === option.value}
          >
            {option.label}
          </Radio>
        ))}
    </RadioToggle>
  );
};

export default Switcher;
